import { useQuery } from "react-query"
import { localConfig } from "../../../Configs/localConfig"
import { api } from "../../api"
import { errorAlert } from "../../../utils/alert"

type Item = {
  cod: number
  cod_usuarios: number
  token: string
  descricao: string
  usuario_nome: string
}

interface CadastroCargos {
  itens: Item[]
  total: number
}

export const useGetComandos = (pagination = 15, page = 1, nome?: string) => {
  const queryKey: any = [`adm/comando-app`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    CadastroCargos,
    Error
  >(
    queryKey,
    async () => {
      const paramNome = nome ? `&nome=${nome}` : ''
      return api
        .get(
          `adm/comando-app?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }&pagination=${pagination}&page=${page}${paramNome}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de comandos!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_comandos: data,
    carregando_comandos: isFetching,
    refetch_data_comandos: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

export const useGetEditarComandos = (cod: number) => {
  const queryKey: any = [`adm/comando-app_${cod}`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    CadastroCargos,
    Error
  >(
    queryKey,
    async () => {
      return api
        .get(
          `adm/comando-app?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }&pagination=-1&cod=${cod}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de comandos!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_comandos_editar: data,
    carregando_comandos_editar: isFetching,
    refetch_data_comandos_editar: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}